import React from 'react';
import { Message } from '@messageformat/react';
import { space } from '@op/opds.tokens';

interface InfoSectionProps {
  icon: React.ReactNode;
  titleId: string;
  bodyId: string;
  body2Id?: string;
}

const InfoSection = ({
  icon,
  titleId,
  bodyId,
  body2Id,
}: InfoSectionProps): React.ReactElement => {
  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          marginBottom: space.default,
        }}
      >
        {icon}
        <h3 className="opds-styles-v1-text-title-large">
          <Message id={titleId} />
        </h3>
      </div>
      <p className="investoracademy-text-paragraph">
        <Message id={bodyId} />
      </p>
      {body2Id && (
        <p className="investoracademy-text-paragraph">
          <Message id={body2Id} />
        </p>
      )}
    </div>
  );
};

export default InfoSection;
